var map = {
	"./1.svg": 35260,
	"./10.svg": 37380,
	"./11.svg": 4901,
	"./12.svg": 66118,
	"./13.svg": 80503,
	"./14.svg": 91320,
	"./15.svg": 95561,
	"./16.svg": 27450,
	"./17.svg": 42059,
	"./18.svg": 15180,
	"./19.svg": 14125,
	"./2.svg": 14287,
	"./20.svg": 57549,
	"./21.svg": 77836,
	"./22.svg": 33183,
	"./23.svg": 28430,
	"./24.svg": 37425,
	"./25.svg": 90976,
	"./26.svg": 45523,
	"./27.svg": 82882,
	"./28.svg": 84082,
	"./29.svg": 84599,
	"./3.svg": 51710,
	"./30.svg": 85298,
	"./31.svg": 39587,
	"./32.svg": 78096,
	"./33.svg": 90337,
	"./34.svg": 81406,
	"./35.svg": 43983,
	"./36.svg": 64956,
	"./37.svg": 35581,
	"./38.svg": 98378,
	"./39.svg": 16219,
	"./4.svg": 60641,
	"./40.svg": 195,
	"./41.svg": 96882,
	"./42.svg": 1921,
	"./43.svg": 10800,
	"./44.svg": 4591,
	"./45.svg": 84542,
	"./46.svg": 30813,
	"./47.svg": 18620,
	"./48.svg": 4507,
	"./49.svg": 52042,
	"./5.svg": 48400,
	"./6.svg": 9891,
	"./7.svg": 55602,
	"./8.svg": 79093,
	"./9.svg": 53460
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21493;